import * as React from "react";
import type { AppConfig } from "@/types/AppConfig";
import { getAsset } from "@/utils/assets";
import { AppConfigContext } from "./AppConfigContext";
import { useTranslation } from "@/hooks/useTranslation";
import { FormConfig } from "@/types/FormConfig";

export type AppConfigProviderProps = {
  children: React.ReactNode;
  config?: FormConfig;
};

const staticAppConfig: AppConfig = {
  home_url: "https://msf.org.uk/",
  charity_registration_number: "1026588",
  logo: {
    src: getAsset("/images/msf.svg"),
    alt: "Médecins Sans Frontières",
    width: 216,
    height: 63,
  },
  title: "",
  amountTitle: "",
  image: "",
  qoute: {
    image: "",
    author: "",
    text: "",
  },
  accordionTitles: {
    createCard: "",
    donationInfo: "",
    paymentType: "",
    yourDetails: "",
    yourAddress: "",
    confirmDetails: "",
  },
  confirmationText: "",
};

export const AppConfigProvider = ({
  children,
  config,
}: AppConfigProviderProps) => {
  const t = useTranslation("form_theme");

  const themeComponent = config?.components?.find((component) => {
    return component.name === "form_theme";
  });

  if (themeComponent) {
    const themeConfig = themeComponent.config;

    const configWithThemeConfig: AppConfig = {
      ...staticAppConfig,
      title: t(themeConfig["form-theme-title"].i18n) as string,
      amountTitle: themeConfig["form-theme-landing-title"]
        ? (t(themeConfig["form-theme-landing-title"].i18n) as string)
        : "Donate to MSF UK. Independent. Neutral. Impartial.",
      image: themeConfig["form-theme-image"].src,
      qoute: {
        image: themeConfig["form-theme-quote-image"].src,
        author: t(themeConfig["form-theme-quote-author"].i18n) as string,
        text: t(themeConfig["form-theme-quote-text"].i18n) as string,
      },
      accordionTitles: {
        createCard: t(
          themeConfig["form-theme-accordeon-create-card"].i18n,
        ) as string,
        donationInfo: t(
          themeConfig["form-theme-accordeon-donation-info"].i18n,
        ) as string,
        paymentType: t(
          themeConfig["form-theme-accordeon-payment-type"].i18n,
        ) as string,
        yourDetails: t(
          themeConfig["form-theme-accordeon-your-details"].i18n,
        ) as string,
        yourAddress: t(
          themeConfig["form-theme-accordeon-your-address"].i18n,
        ) as string,
        confirmDetails: t(
          themeConfig["form-theme-accordeon-confirm-details"].i18n,
        ) as string,
      },
      confirmationText: t(
        themeConfig["form-theme-confirmation-text"].i18n,
      ) as string,
    };

    return (
      <AppConfigContext value={configWithThemeConfig}>
        {children}
      </AppConfigContext>
    );
  }

  return (
    <AppConfigContext value={staticAppConfig}>{children}</AppConfigContext>
  );
};
